export default "__VITE_ASSET__BmBRun2a__"